const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const getTitle = (string) => capitalize(string.replace('-', ' '));
